import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { throwError } from 'rxjs';
import { catchError, filter, map, take, tap } from 'rxjs/operators';

import { ToastService } from '@libs/src/toast/toast.service';

import { Group } from '@libs/src/models/group.model';
import { MatchState } from '@libs/src/models/match.interfaces';

import { IAppState } from '../../app.state';
import {
  getMatchesStatesForGroup,
  getMostRecentMatchState,
} from '../../matches/match.helpers';
import { FindMatchForGroup, GetMatch } from '../../matches/matches.actions';

import { GroupsService } from '../groups.service';

import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';

@Component({
  selector: 'app-group-match-view',
  templateUrl: './group-match-view.component.html',
})
export class GroupMatchViewComponent implements OnInit {
  constructor(
    private groupsService: GroupsService,
    private router: Router,
    private route: ActivatedRoute,
    private store: Store<IAppState>,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    const groupSlug = this.route.snapshot.paramMap.get('groupSlug');
    const matchId = this.route.snapshot.paramMap.get('matchId');
    this.groupsService
      .resolveGroup(groupSlug)
      .pipe(
        catchError((response: HttpErrorResponse) => {
          this.router.navigate(['/home'], {
            replaceUrl: true,
          });
          return throwError(response);
        }),
        tap((group: Group) => this.redirectToConversation(group)),
        tap((group: Group) => {
          return matchId
            ? this.store.dispatch(GetMatch({ group, matchId }))
            : this.store.dispatch(FindMatchForGroup(group));
        }),
      )
      .subscribe();
  }

  redirectToConversation(group: Group) {
    this.store
      .select('matches')
      .pipe(
        filter((matchStates: MatchState[]) => {
          const matchStatesForGroup = getMatchesStatesForGroup(
            matchStates,
            group._id,
          );
          return !isEmpty(matchStatesForGroup);
        }),
        take(1),
        map((matchesState: MatchState[]) => {
          const matchStatesForGroup = getMatchesStatesForGroup(
            matchesState,
            group._id,
          );
          const matchState = getMostRecentMatchState(matchStatesForGroup);
          if (get(matchState, 'error.message')) {
            this.toastService.showError(get(matchState, 'error.message'));
            return this.router.navigate(['/home'], {
              queryParams: {
                group: group._id,
              },
              replaceUrl: true,
            });
          }
          return this.router.navigate(
            ['conversations', matchState.document.conversation],
            { replaceUrl: true },
          );
        }),
      )
      .subscribe();
  }
}
